/*
 * @Author: your name
 * @Date: 2020-09-29 08:34:43
 * @LastEditTime: 2020-10-24 13:58:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import '../static/styles/style.scss'

import state from '../static/js/state.js'

import '../static/iconfont/iconfont.css'
import 'default-passive-events'
import * as filters from '../static/js/filter'
import http from '../static/js/http'
import api from '../static/js/api'
import oauthapi from '../static/js/oauthapi'
 import store from '../static/js/store'
 import stateType from '../static/js/state'


Vue.prototype.http=http
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.state=state
Vue.prototype.api=api
Vue.prototype.oauthapi=oauthapi
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data() {
    return {
      stateType,
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js